<template>
  <Layout>
    <v-row justify="center" class="my-2">
      <h3>ประวัติการบันทึกข้อมูล</h3>
    </v-row>
    <template v-if="loading">
      <v-skeleton-loader
        v-bind="attrs"
        type="table-heading, list-item-two-line, image, table-tfoot"
      ></v-skeleton-loader>
    </template>
    <template v-else>
      <v-row>
        <v-col class="d-flex justify-start">
          <v-btn elevation="2" @click="goBack"> ย้อนกลับ </v-btn>
        </v-col>
      </v-row>
      <br />
      <v-row>
        <v-col>
          <TableAllActivity v-if="activity" :data="activity" />
        </v-col>
      </v-row>
    </template>
  </Layout>
</template>

<script>
import Layout from '@/components/Layout'
import TableAllActivity from '@/components/TableAllActivity'
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      me: (state) => state.me.data,
      activity: (state) => state.job.activity,
      activityLoading: (state) => state.job.isLoading,
    }),
    loading() {
      return this.activityLoading
    },
  },

  components: {
    TableAllActivity,
    Layout,
  },

  data() {
    return {}
  },

  async mounted() {
    const payload = {
      id: this.$route.params.id,
      storeId: this.$route.params.storeId,
    }
    await this.$store.dispatch('job/getAllActivity', payload)
  },

  methods: {
    goBack() {
      this.$router.push({
        name: 'StoreDetail',
        params: {
          id: this.$route.params.id,
          storeId: this.$route.params.storeId,
        },
      })
    },
  },
}
</script>
